export default function ButtonsTableEdit(props) {
  const {className, ...restProps} = props

  return (
    <EditButton className={classNames("components-buttons-table-edit", className)} {...restProps} />
  )
}
